<template>
  <div>
    <!--轮播-->
    <header class="header">
      <van-swipe :autoplay="3000" indicator-color="white">
        <van-swipe-item v-for="i in 5" :key="'header' + i">
          <div class="my-swipe" v-if="shop[`IMG${i}`]">
            <img alt="" v-lazy="shop[`IMG${i}`] + '?x-oss-process=style/medium'">
          </div>
        </van-swipe-item>
      </van-swipe>
      <h4 class="hotel-name">{{ shop.name }}</h4>
    </header>
    <!--地址-->
    <section class="box flex-between">
      <div>
        <h4>{{ shop.address }}</h4>
        <a :href="`tel:${ shop.telno }`" class="phone flex-start mt-1x">
          <van-icon name="phone" size="20"></van-icon>  {{ shop.telno }}
        </a>
      </div>
      <div class="text-c" @click="showImagePosters = true">
        <van-icon name="share" />
        <p>海报</p>
      </div>
    </section>
    <!--折叠面板-->
    <van-collapse v-model="activeName" accordion class="mt-1x" @change="handleChange">
      <van-collapse-item v-for="(item, index) in hotelList" :key="index" :name='index'>
        <template slot="title">
          <div class="flex-start">
            <div class="avatar square large relative" @click.stop="seeInfo(index)">
              <img alt="" class="fill" v-lazy="item['IMGS'][0] + '?x-oss-process=style/small'">
              <div class="flex-around tip-num">{{item.IMGS.length}}</div>
            </div>
            <div class="ml-2x">
              <h4>{{item.ROOM_TYPE_DESCRIPTION}}</h4>
              <p class="gray font-s">{{item.RATE_CODE_DESCRIPTION}}</p>
              <div class="flex-start">
                <p class="font-s" style="text-decoration: line-through">原价：¥{{item.RATE}}</p>
                <div class="ml-2x" v-if="item.minPrice > 0">
                  <span class="font-s red">¥</span>
                  <b class="red" style="font-size: 18px">{{item.minPrice}}</b>
                  <span class="font-s gray"> 起</span>
                </div>
              </div>
            </div>
          </div>
        </template>
        <div class="flex-between pb-2x" v-for="(temp,index) in specList" :key="index">
          <div class="text flex-grow">
            <h4 class="name">{{activityName}}</h4>
            <p class="desc">{{temp.NAME}}</p>
          </div>
          <h3 class="red mh-2x"><span class="font-s">￥</span>{{temp.PRICE}}</h3>
          <div class="booking-btn" @click="changeRoom(temp)">
            <div class="book">订</div>
            <p class="primary">在线付</p>
          </div>
        </div>
      </van-collapse-item>
    </van-collapse>
    <!--日历-->
    <aki-date
        v-if="show"
        :visible="show"
        :initDate="now"
        :custom="data"
        :selectArea="selectArea"
        @confirm="select"
        @cancel="cancel"
        @disable="selectErr"
        autoComplete
    />
    <!-- 酒店明细 start -->
    <van-popup
        v-model="infoDialog"
        position="bottom"
        style="min-height: 100%"
    >
      <header class="close primary" @click="infoDialog = false">
        <van-icon name="close" size="32"/>
      </header>
      <van-swipe :autoplay="3000" indicator-color="white">
        <van-swipe-item v-for="(item, i) in roomDetail.IMGS" :key="'room' + i">
          <div class="my-swipe">
            <img :src="item + '?x-oss-process=style/medium'" alt="">
          </div>
        </van-swipe-item>
      </van-swipe>
      <ul class="list no-pd">
        <li class="item">
          <h4 class="title">床规格：</h4>
          <template v-for="i in 3">
            <div class="desc mt-x flex-between" :key="`d${i}`" v-if="roomDetail[`BED${i}_DESC`]">
              <p>{{roomDetail[`BED${i}_DESC`]}}</p>
              <p>x{{roomDetail[`BED${i}_QTY`]}}</p>
            </div>
          </template>
        </li>
        <li class="item" v-if="roomDetail.NOTE">
          <h4 class="title">房型说明：</h4>
          <div class="desc mt-x">{{roomDetail.NOTE}}</div>
        </li>
        <li class="item" v-for="item in desc" :key="item.key">
          <h4 class="title">{{item.title}}：</h4>
          <div class="desc mt-x">{{item.content}}</div>
        </li>
      </ul>
    </van-popup>
    <!--海报分享-->
    <van-popup v-model="showImagePosters" closeable
               position="bottom"
               style="height: 100vh"
    >
      <div @click="showImagePosters = false">
        <img :src="imagePosters" alt="" class="res">
      </div>
    </van-popup>
  </div>
</template>

<script>
import AkiDate from '@/components/DatePicker'
import { getStore, setStore } from '../config/utils'
import QRCode from 'qrcode'
export default {
  name: 'Order',
  components: {
    AkiDate
  },
  data () {
    return {
      now: this.$date(),
      shop: JSON.parse(localStorage.getItem('setShop')), // 主页轮播图
      selectArea: [],
      hotelList: [], // 房间列表
      infoDialog: false, // 酒店详情dialog
      desc:'', // 详情描述列表
      hotelInfo: [], // 房间明细描述
      activityName: '', // 选中的房间名字
      activityType: '', // 选中的房间类型
      specList: [], // 规格明细列表
      roomDetail: {}, // 房型明细
      data: [], // 日历
      // data: ['￥1300', '￥1345', { highlight: true, text: '￥999' }],
      show: false,
      activityRoom:'',// 选中的房间规格
      // maxRoomNum: 1, // 预定时，最大可以选择的房间数量

      user: JSON.parse(localStorage.getItem('setUserInfo')),
      activeName: '',
      showImagePosters: false,
      imagePosters: '', // 海报图片
      posterId: '', // 分享id
    }
  },
  created() {
    const token = this.$cookies.get('hotel_token')
    if(token){
      // 初始化房间列表
      this.handleGetRoom()
      if (localStorage.getItem('memebrId')) this.getNewShare()
      else {
        this.poster()
      }
    }
    // 监听滚动
    // window.addEventListener('scroll', this.handleScroll, true)
  },
  methods: {
    // 获取房间列表
    handleGetRoom() {
      let member = localStorage.getItem('member')
      const params = {}
      // 根据会员等级获取房价
      if (member) {
        member = JSON.parse(member)
        if (member.card_type_id) params.card_type_id = member.card_type_id
      }
      this.$fetch({
        url:'/api/Reservation/Schedule',
        params
      })
      .then(res => {
        res.data.forEach(item => {
          item.minPrice = 0
          // 找出最低价格
          if (item.RATE_CODE_LST_JSON.length) {
            item.minPrice = item.RATE_CODE_LST_JSON[0].PRICE
            item.RATE_CODE_LST_JSON.forEach(temp => {
              if (item.minPrice > temp.PRICE) item.minPrice = temp.PRICE
            })
          }
          item.IMGS = JSON.parse(item.IMGS)
          // 兼容之前版本的图片
          for (let i = 1; i < 5; i++) {
            if ( item[`IMG${i}`] && item[`IMG${i}`].split(',')[1]) {
              item.IMGS.push(item[`IMG${i}`].split(',')[1])
            }
          }
        })
        this.hotelList = res.data
      })
    },
    getNewShare() {
      this.$fetch({
        url: '/api/app_share/NewShare',
        method: 'post',
        data: {
          // share_type: 0：业务系统产品推荐 1：会员卡券推荐 3:会员产品推荐 4：图文网页推荐
          share_type: 0,
          share_member_id: localStorage.getItem('memberId'),
          site_id: localStorage.getItem('siteId')
        }
      })
        .then(res => {
          this.posterId = res.share_id
          this.poster()
        })
    },
    // 画图
    poster() {
      let url = `${location.origin}${location.pathname}#/order?a=${localStorage.getItem('appId')}&t=${localStorage.getItem('server')}`
      if (this.posterId) url += `&shareId=${this.posterId}`
      console.log(url)
      QRCode.toDataURL(url)
        .then(src => {
          const canvas = document.createElement('canvas')
          let width = this.$getViewportSize().width * 2
          let height = this.$getViewportSize().height * 2
          canvas.width = width
          canvas.height = height
          let ctx = canvas.getContext('2d')
          let bgImg = new Image()
          let qrImg = new Image()
          bgImg.setAttribute('crossOrigin', 'Anonymous') // 允许跨域
          bgImg.src = this.shop['IMG' + 6]
          bgImg.onload = () => { // 海报背景加载完成
            ctx.drawImage(bgImg, 0, 0, width, height)
            qrImg.src = src
            qrImg.onload = () => { // 二维码加载完成
              ctx.drawImage(qrImg, canvas.width - 208, canvas.height - 208, 200, 200)
              ctx.fillStyle = 'rgba(0,0,0,0.5)'
              ctx.fillRect(width / 2 - 104, height - 76, 210, 60)
              ctx.font = '32px Arial' // 文字大小
              ctx.fillStyle = '#ffffff' // 颜色
              ctx.textAlign = 'center'
              ctx.fillText('长按图片分享', width / 2, height - 32)
              this.imagePosters = canvas.toDataURL('image/png', 0.95)
            }
          }
        })
    },
    // 查看房间明细dialog
    seeInfo(index) {
      this.infoDialog = true
      this.roomDetail = this.hotelList[index]
      const shop = JSON.parse(getStore('setShop'))
      this.desc = JSON.parse(shop.note)
    },
    // 打开折叠列表，选择规格
    handleChange(index) {
      if(index !== null && index !== "undefined" && index !== ""){
        const info = this.hotelList[index]
        this.activityName = info.ROOM_TYPE_DESCRIPTION
        this.activityType = info.ROOM_TYPE_ID
        // 如果有设置房价代码，则可以预定
        if (info.RATE_CODE_LST_JSON.length) {
          this.specList = info.RATE_CODE_LST_JSON
        }
        else {
          this.specList = []
        }
        // 2020-07-04注释
        // else {
        //   this.specList = []
        //   const item = {
        //     ID: info.RATE_CODE_ID,
        //     NAME: info.RATE_CODE_DESCRIPTION,
        //     PRICE: info.RATE
        //   }
        //   this.specList.push(item)
        // }
      }
    },
    // 选择房价代码，传回后台，获取价格
    changeRoom(item){
      this.activityRoom = {
        name: this.activityName,
        room_type: this.activityType,
        spec: item
      }
      const d = new Date()

      let nowDay = d.Format("dd/MM/yyyy")
      d.setMonth(d.getMonth()+6)
      // console.log('今天:',nowDay)
      // console.log('半年后:',end_date)
      // const params = 'start_date='+nowDay+'&end_date='+end_date+'&room_type='+this.activityType+'&rate_code='+item.ID
      this.$fetch({
        url: '/api/Reservation/Availability',
        params: {
          start_date: nowDay,
          end_date: d.Format("dd/MM/yyyy"),
          room_type: this.activityType,
          rate_code: item.ID
        }
      })
        .then(res => {
          let start = res.data[0].AVAIL_DATE.split('/').reverse().join('-')
          let end = res.data[res.data.length - 1].AVAIL_DATE.split('/').reverse().join('-')
          this.selectArea = [start, end]
          this.data = res.data.map(item => {
            const obj = {}
            if (item.ROOMS_AVAIL <= 0) {
              obj.disabled = true
              obj.bgc = '#eee'
              obj.info = {
                text: '满房'
              }
            } else {
              obj.info = [
                {
                  text: `${item.ROOMS_AVAIL}间`,
                  color: '#2db7f5'
                },
                {
                  text: '￥'+ item.RATE,
                  color: '#F08E24'
                }
              ]
              obj.price = item.RATE
              obj.maxRoomNum = item.ROOMS_AVAIL // 设置最大的可选房间数
            }
            return obj
          })
          this.show = true
        })
    },
    // 点击【打开】选择日期
    select({ start, end, range}) {
      // console.log(range)
      if (!start) {
        this.$toast('请选择入住日期')
        return
      }
      if (!end) {
        this.$toast('请选择离店日期')
        return
      }
      // 防止日历控件入住和离店选同一天问题
      if (end.date <= start.date) {
        this.$toast('请正确选择日期')
        return
      }
      this.show = false
      // console.log('this.data',this.data)
      // 组装订单页面数据
      const info = {
        start: {
          date: this.$date(start.date),
          custom: start.data.custom
        }, // 开始日期
        end: {
          date: this.$date(end.date),
          custom: end.data.custom
        }, // 开始日期, // 结束日期
        range: range,  // 选中时间段
        room: this.activityRoom // 选择的房间
      }
      setStore('orderInfo', info)
      this.$router.push('/booking')
    },
    // 取消选择
    cancel() {
      this.show = false
    },
    selectErr(date) {
      this.$dialog.alert({
        title: '提示',
        message: `非常抱歉！${this.$date(date.date)}已满房`,
      })
      .then(() => {})
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
@import '../assets/css/var.less';
.header{
  position: relative;
  .hotel-name{
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    height: 32px;
    line-height: 32px;
    color: white;
    text-align: center;
    background: rgba(0,0,0,0.3);
  }
}
.my-swipe{
  height: 50vw;
  text-align: center;
  img{
    height: 100%;
    width: 100%;
  }
}

.tip-num{
  position: absolute;
  bottom: 4px;
  right: 4px;
  width: 18px;
  height: 18px;
  font-size: 10px;
  border-radius: 50%;
  color: #fff;
  background: rgba(0,0,0,0.5);
}

.booking-btn{
  width: 64px;
  border: 1px solid #FF6914;
  border-radius: 4px;
  text-align: center;
  .book{
    background-color: #FF6914;
    width: 100%;
    font-size: .7rem;
    color: #ffffff;
    padding: 4px 0;
    border-radius: 4px 4px 0 0;
  }
}
.close{
  position: fixed;
  right: 8px;
  top: 8px;
  z-index: 1;
}

.content main .aki-month > header{
  font-weight: 600;
}
.content main .aki-month .day-wrap .day.disabled > span{
  color: #7b7b7b !important;
}
.content main .aki-month .day-wrap .day.select{
  background-color:#409eff
}
.content main .aki-month .day-wrap .day:nth-child(2){
  font-weight: 600;
}
</style>
